<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券名称" prop="couponName">
                <a-input v-model="queryParam.couponName" placeholder="请输入优惠券名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="适用时间" prop="enableTime">
                  <a-select placeholder="请选择适用时间" style="width: 100%" v-model="queryParam.enableTime" allowClear>
                    <a-select-option
                      v-for="(item, index) in this.customDict.CouponCouponUserEnableTimeEnum"
                      :value="item.type"
                      :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">

        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:coupon:add']">
          <a-icon type="plus" />新增通用优惠券
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['coupon:coupon:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:coupon:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['coupon:coupon:export']">
          <a-icon type="download" />导出
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">

          <a-divider v-if="record.shopId == 0" type="vertical" v-hasPermi="['coupon:coupon:edit']" />
          <a v-if="record.shopId == 0" @click="$refs.userCouponList.open(record.id)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="user" />发放用户
          </a>

          <a-divider type="vertical" v-hasPermi="['coupon:coupon:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:coupon:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
        <span slot="enableTime" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（标签）-->
          <custom-dict-tag :options="customDict.CouponCouponUserEnableTimeEnum" :value="record.enableTime"/>
        </span>
        <span slot="isPause" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（下架）-->
          <custom-dict-tag :options="customDict.TFEnum" :value="record.isPause"/>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <user-coupon-list ref="userCouponList"></user-coupon-list>
  </page-header-wrapper>
</template>

<script>
import { listCoupon, delCoupon } from '@/api/coupon/coupon'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import UserCouponList from './modules/UserCouponList.vue'
export default {
  name: 'Coupon',
  components: {
    CreateForm,
    CustomDictTag,
    UserCouponList
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        shopId: null,
        shopName: null,
        couponName: null,
        couponAmount: null,
        couponCondition: null,
        enableTime: null,
        validDay: null,
        totalNum: null,
        remainNum: null,
        isPause: null,
        rule: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠金额 单位(元)',
          dataIndex: 'couponAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '满xx可用 单位(元)',
          dataIndex: 'couponCondition',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '适用时间',
          dataIndex: 'enableTime',
          ellipsis: true,
          scopedSlots: { customRender: 'enableTime' },
          align: 'center'
        },
        {
          title: '可用有效期',
          dataIndex: 'validDay',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总发放数量',
          dataIndex: 'totalNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剩余发放数量',
          dataIndex: 'remainNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否暂停发放',
          dataIndex: 'isPause',
          ellipsis: true,
          scopedSlots: { customRender: 'isPause' },
          align: 'center'
        },
        {
          title: '使用规则',
          dataIndex: 'rule',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: { ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 查询优惠券信息列表 */
    getList () {
      this.loading = true
      listCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        shopId: undefined,
        shopName: undefined,
        couponName: undefined,
        couponAmount: undefined,
        couponCondition: undefined,
        enableTime: undefined,
        validDay: undefined,
        totalNum: undefined,
        remainNum: undefined,
        isPause: undefined,
        rule: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delCoupon(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('coupon/coupon/export', {
            ...that.queryParam
          }, `coupon_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
